import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 56,
      width: "100%",
      background: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      zIndex: 9,
      boxSizing: "border-box",
    },

    container: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 24px",
      boxSizing: "border-box",
      direction: "ltr",
    },

    leftSection: {
      display: "flex",
      alignItems: "center",
      gap: 16,
      justifyContent: "flex-start",
    },

    rightSection: {
      width: 280,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },

    userBox: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      cursor: "pointer",
      direction: "ltr",
    },

    arrowIcon: {
      fontSize: "20px !important",
      color: "#6E758D",
    },

    avatar: {
      width: "28px !important",
      height: "28px !important",
      fontSize: "12px !important",
      backgroundColor: "#DDF3FF !important",
      color: "#5B8DAE !important",
    },

    userName: {
      fontFamily: "Noto Sans Hebrew",
      fontWeight: "400 !important",
      fontStyle: "normal",
      fontSize: "12px !important",
      leadingTrim: "cap-height",
      lineHeight: "24px !important",
      letterSpacing: "0.1px",
      textAlign: "right",
      color: "#6E758D",
      whiteSpace: "nowrap",
    },

    notificationBox: {
      width: 28,
      height: 28,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },

    notificationIcon: {
      fontSize: "20px !important",
      color: "#6E758D",
    },

    search: {
      width: "100%",

      "& .MuiOutlinedInput-root": {
        height: 32,
        borderRadius: 4,
        background: "#FFFFFF",
        direction: "ltr",
        paddingLeft: "8px",
        paddingRight: "8px",

        "& fieldset": {
          borderColor: "#E5EAF2",
        },

        "&:hover fieldset": {
          borderColor: "#D5DCE8",
        },

        "&.Mui-focused fieldset": {
          borderColor: "#D5DCE8",
        },
      },

      "& .MuiOutlinedInput-input": {
        padding: "5px 8px",
        fontSize: 13,
        color: "#6E758D",
        textAlign: "right",
        fontFamily: "Mona-Sans",
        direction: "rtl",
      },

      "& .MuiOutlinedInput-input::placeholder": {
        color: "#9AA3B5",
        opacity: 1,
        textAlign: "right",
      },
    },

    searchIcon: {
      fontSize: "26px !important",
      color: "#6E758D",
      marginRight: 6,
      transform: "scaleX(-1)",
      display: "flex",
      alignItems: "center",
    },

    versionInfo: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#aaa",
      padding: "10px 16px",
      fontSize: "12px !important",
    },

    userMenu: {
      "& .MuiPaper-root": {
        top: "42px !important",
        left: "19px !important",
      },
    },

    userMenuPaper: {
      width: "135px !important",
      minWidth: "135px !important",
      maxWidth: "135px !important",
      borderRadius: "4px !important",
      borderWidth: "1px !important",
      borderStyle: "solid !important",
      borderColor: "#E5EAF2 !important",
      opacity: "1 !important",
      transform: "rotate(0deg) !important",
      boxShadow: "0 4px 16px rgba(37, 56, 88, 0.12) !important",
      padding: "4px 0 !important",
      overflow: "hidden",
      boxSizing: "border-box",
    },

    userMenuList: {
      padding: "0 !important",
      direction: "rtl",
    },

        userMenuItem: {
      display: "flex !important",
      alignItems: "center !important",
      gap: "8px !important",
      minHeight: "36px !important",
      padding: "8px 12px !important",
      direction: "rtl",
      backgroundColor: "transparent !important",

      "&:hover": {
        backgroundColor: "#F5F7FA !important",
      },

      "&.Mui-focusVisible, &:focus": {
        backgroundColor: "transparent !important",
      },

      "&.Mui-focusVisible:hover, &:focus:hover": {
        backgroundColor: "#F5F7FA !important",
      },
    },

    userMenuIcon: {
      flexShrink: 0,
      width: 20,
      height: 20,
      display: "block",
    },

    userMenuLabel: {
      fontFamily: "Noto Sans Hebrew !important",
      fontWeight: "400 !important",
      fontSize: "14px !important",
      lineHeight: "20px !important",
      color: "#79808A !important",
      textAlign: "right",
    },

    userMenuDivider: {
      margin: "4px 0 !important",
      borderColor: "#EEF1F6 !important",
    },

    logoutModal: {
      position: "absolute",
      background: "#FFFFFF",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "560px",
      minHeight: "182px",
      border: "0px",
      boxShadow: "0",
      zIndex: "9999",
    },

    CardActions: {
      justifyContent: "center",
      marginTop: "30px",
      marginRight: "28px",
    },

    cardContent: {
      marginLeft: "17px",
      marginTop: "12px",
    },

    bodyTypography: {
      fontWeight: "400 !important",
      fontSize: "16px !important",
      lineHeight: "24px !important",
      letterSpacing: "0.5px !important",
      color: "rgba(0, 0, 0, 0.6)",
    },

    headTypography: {
      color: "#000000",
      fontWeight: "550 !important",
      fontSize: "21.5px !important",
      lineHeight: "24px !important",
      letterSpacing: "0.15px !important",
    },

    btnNo: {
      color: "#88929C !important",
      paddingRight: "38px !important",
      fontWeight: "500 !important",
      fontSize: "14px !important",
      lineHeight: "16px !important",
      letterSpacing: "0.0125rem !important",
    },

    btnLogout: {
      fontWeight: "500 !important",
      fontSize: "14px !important",
      lineHeight: "16px !important",
      letterSpacing: "0.0125rem !important",
    },

    menu: {
      marginTop: "45px",
    },

    menuPaper: {
      borderRadius: "8px",
      minWidth: "200px",
      padding: "8px 0",
    },

    menuList: {
      padding: 0,
      direction: theme.direction,
    },

    menuItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },

    logoutIcon: {
      marginRight: -1.5,
    },

    transparentDivider: {
      borderColor: "transparent",
    },
  })
);